import { HeaderContainer, StyledContainer, StyledTitle } from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/Tools/styled-components'
import useTabBar from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useTabBar'
import ExportLogs from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/Tools/ExportLogs/ExportLogs'
import HistoricAuditLogs from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/Tools/HistoricAuditLogs/HistoricAuditLogs'
import ChangeUser from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/Tools/ChangeUser/ChangeUser'
import ZohoButton from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/Tools/ZohoButton/ZohoButton'
import AbandonContract from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/Tools/AbandonContract/AbandonContract'
import Comments from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/Tools/Comments/Comments'
const Tools = () => {
  const { t } = useTabBar()

  return (
    <StyledContainer>
      <HeaderContainer>
        <StyledTitle>{t('subscriptionTools:tools.module_title')}</StyledTitle>
      </HeaderContainer>
      <ZohoButton />
      <ExportLogs />
      <HistoricAuditLogs />
      <ChangeUser />
      <AbandonContract />
      <Comments />
    </StyledContainer>
  )
}

export default Tools
